import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionSubHeading, SectionWrapper } from "../../../Styles/style";
import aboutimg from "../../../../assets/images/aboutimg.png"
import { BuyNow } from "../S1_Header/styles";
import { useTheme } from "@emotion/react";

const AboutImage = styled.img`
  width: 100%;
  height: auto;
  /* max-width: 80%; */
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`; const GridHEading = styled(Grid)`
/* padding: 50px 0; */
align-items: center;
place-content: ${(props) => (props.pc ? props.pc : "")};
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
`;
const GridImagecenter = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;
text-align-last: center;

`;
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "450px")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const FeatureWrapper = styled.div`
 background: #151515;GridImage
  text-align:center;
border-radius:20px;
  padding: 20px;
  height:440px;
  
  @media screen and (max-width:499px){
  height: 550px;

 }
`
const Wrap = styled.div`

background-size: cover;
background-repeat: no-repeat;
background-position:center;
    min-height: 506px;
    display: flex;
    align-items: center;
    padding:40px 30px;
    border-radius:30px;
    @media screen and (max-width:499px){
/* margin:0 0 0 20px; */

 }

`
const S2_Aboutus = () => {
  const theme = useTheme()
  return (
    <div>
      <SectionWrapper bgColor="#000" p="2rem 0 0" p799="0" p599="0" id="About">
        <Container maxWidth="xl">

          <GridHEading container columnSpacing={2} rowSpacing={3}>
          <GridImage item xs={12} md={12}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              <SectionHeading
                fs="70px"
                p="30px 0"
                m="0"
                align="left"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
                style={{textAlign:'center',paddingBottom:'0'}}
              >About Shib
              </SectionHeading></GridImage>
            <GridImage item xs={12} md={6}
              data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              {/* <SectionHeading
                fs="70px"
                p="30px 0"
                m="0"
                align="left"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >About Shib
              </SectionHeading> */}


              <P align="LEFT"
                p="0 0 40px 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
             Welcome to the Pulse network's Shib,
              where innovation meets democracy! Shib
              is a variant of the popular Shiba Inu
              coin, but with a twist. By launching on
              the Pulse Network, Shib offers a bot-
              free experience, ensuring fair and
              transparent transactions for all. Our
              vibrant community is driven by our
              shared love for Shiba Inus and the
              passion for revolutionizing the
              cryptocurrency world. Join us on this
              exciting journey as we unleash the full
              potential of Shib!
               </P>
              {/* <BuyNow >OTC TG Group</BuyNow> */}



            </GridImage>
            <GridImagecenter item xs={12} md={6} data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="200"
              data-aos-duration="500"
              data-aos-offset="0">

              <JOiningLinks src={aboutimg} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="600"
                data-aos-offset="0" />
            

            </GridImagecenter>
          </GridHEading>

        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
